function checkAdmin(address?: string) {
  if (!address) return false;
  return ['0xbfACc5ffF51d5Da3C4B32cbc1189bF13bC37e5a7', '0xF16Aa7E201651e7eAd5fDd010a5a14589E220826'].includes(address);
}

export default checkAdmin;
